<script>
    export let row = null;
    export let col = '';
</script>

<style>
    .shortened-url {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
    }
</style>

<div class="shortened-url" title="{row[col]}">
    <a href="{row[col]}" target="_blank" rel="noopener noreferrer">{row[col] ? row[col] : ''}</a>
</div>